// extracted by mini-css-extract-plugin
export var cardHeader = "_ih-1";
export var contentCard = "_ih-0";
export var headerActions = "_ih-3";
export var reorderHandle = "_ih-5";
export var titleArea = "_ih-2";
export var titleAreaWithHandle = "_ih-4";